module.exports = __webpack_public_path__ + "static/95-03d692bef80ac5e6c5af52000e695617.png";